import { groupBy } from "lodash";
import api from "../config/api";
import moment from "moment-timezone";
const BUSINESS_TZ = "America/Toronto";

export const getContracts = async (data) => {
  const res = await api.get("contracts", data);
  return res.data;
};

export const getContractById = async (_id) => {
  const res = await api.get(`contracts/${_id}`);
  return res.data;
};

export const getContractScheduleDetails = async (contractId) => {
  const res = await api.get(`contracts/schedule/${contractId}`);
  return res.data;
};

export const getPosGroupedByOrg = async () => {
  const res = await api.get("contracts");
  return groupBy(res.data, (i) => i.organization);
};

export const getInvoices = ({ contracts = [] }) => {
  const invoices = [];
  const MONTH_COUNT_PER_INVOICE = 1;

  contracts.forEach((contract) => {
    //Force Montreal timezone immediately
    const contractStart = moment.tz(contract.contractStartDate, BUSINESS_TZ);

    const contractEnd = moment.tz(contract.contractEndDate, BUSINESS_TZ);

    const monthPeriods = [];

    let cursor = contractStart.clone().startOf("month");

    while (cursor.isSameOrBefore(contractEnd, "month")) {
      const isFirstMonth = cursor.isSame(contractStart, "month");
      const isLastMonth = cursor.isSame(contractEnd, "month");

      const from = isFirstMonth
        ? contractStart.clone() // mid-day allowed
        : cursor.clone().startOf("month").startOf("day"); // 1st 00:00:00 Montreal

      const to = isLastMonth
        ? contractEnd.clone()
        : cursor.clone().endOf("month").endOf("day"); // last day 23:59:59 Montreal

      monthPeriods.push({
        from: from.clone().utc().toISOString(), // convert AFTER calculation
        to: to.clone().utc().toISOString(),
      });

      cursor.add(1, "month");
    }

    let remaining = monthPeriods.length;
    let index = 0;

    while (remaining > 0) {
      const monthCount = Math.min(MONTH_COUNT_PER_INVOICE, remaining);
      const price = monthCount * contract.monthly_payment_cost;

      invoices.push({
        month_count: monthCount,
        price,
        startDate: monthPeriods[index].from,
        endDate: monthPeriods[index + monthCount - 1].to,
        tax: 13,
        total: (price * 1.13).toFixed(2),
        contract,
      });

      index += monthCount;
      remaining -= monthCount;
    }
  });

  return invoices;
};
